import TransfersPage from "components/pages/TransfersPage";
import TransferReviewPage from "components/pages/TransferReviewPage";
import TransferConfirmPage from "components/pages/TransferConfirmPage";
import { useGlobalController, useModel, useParams, Workflow, BCMSRecord } from "bcms-react";
import Classes, { TransferTemplate } from "model";
import MakeTransfer from "./classes/MakeTransfer";
// Steps of the workflow
const steps = [ TransfersPage, TransferReviewPage, TransferConfirmPage ];

export default function MakeTransferWorkflow(props) {
    // Initalize global controller
    const controller = useGlobalController();
    const {stepID} = useParams();
    const model = useModel();
    const { branding } = useModel();
    
    // Get the default autopay and return the workflow component
    const value = getDefaultTransfer(controller, model);
   
    const constructor = record => {
        const defaultValues = getDefaultTransfer(controller, model);
        const data = { ...defaultValues.data, transfer: MakeTransfer.init(record) };

        return { ...defaultValues, data };
    };
    
    return <Workflow value={ value } steps={ steps } step={ stepID } constructor={ constructor } />
}
// getDefaultTransfer :: bcmsGlobalController, STRING -> {  }
// Initalize and return the default information for the workflow
export const getDefaultTransfer = (controller, model) => {
    BCMSRecord.globalControllerFor(Classes, controller);
    const user = model ? model.user : {};

    // Note: user settings determine how transfers are made, 
    // so using templates, using only templates, or no templates at all.
    const allowTransferOnlyTemplates = user.allowTransferOnlyTemplates === "true";
    const transfer = MakeTransfer.init({ templateOnly: allowTransferOnlyTemplates });

    return {
        data: {
            transfer: transfer
        }
    };
};

// Return the steps of the workflow
export const getWorkflowSteps = () => steps;